import React from "react";
import { Link } from "react-router-dom";

export default function PageBanner(props) {
  return (
    <section
      className={`PageBanner ${
        props.mode === "light" ? "lightBanner" : "darkBanner"
      }`}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 col-md-10">
            <div className="pagebannerHeadings">
              
              {props.pageLabel && (
                <span
                  className="pageBannerLabel brandText"
                  data-aos="fade-down"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="800"
                  data-aos-delay="200"
                >
                  {props.pageLabel}
                </span>
              )}

              <h2
                data-aos="fade-down"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
                data-aos-delay="300"
                className={`${
                  props.mode === "light" ? "text-dark" : "text-white"
                }`}
              >
                {props.pageBannerHeading}
              </h2>

              <h4
                data-aos="fade-down"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
                data-aos-delay="400"
                className="brandText line-hight-5"
              >
                {props.pageBannerSubHeading}
              </h4>

              {props.breadcrumb && (
                <div
                  className={`pageBreadcrumb ${
                    props.mode === "light" ? "text-dark" : "text-white"
                  }`}
                  data-aos="fade-up"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="800"
                  data-aos-delay="500"
                >
                  <Link to="/">Home</Link>
                  <span>/</span>
                  <span>{props.pageBannerHeading}</span>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}